import ApiService from './ApiService'

// Admin scoped lists
export const apiListRoles = () => ApiService.get('/admin/list/roles')
export const apiListMachineTypes = () => ApiService.get('/admin/list/machine-types')
export const apiListMachines = () => ApiService.get('/admin/list/machines')
export const apiListTerms = () => ApiService.get('/admin/list/terms')
export const apiListCustomers = () => ApiService.get('/admin/list/customers')
export const apiListServiceStaffs = () => ApiService.get('/admin/list/service-staffs')

// Admins
export const apiAdminsList = data => ApiService.get('/admin/admins', data)
export const apiAdminsView = id => ApiService.get(`/admin/admins/${id}`)
export const apiAdminsForm = (id, data) => ApiService.post(`/admin/admins${id ? `/${id}` : ''}`, data)
export const apiAdminsStatus = id => ApiService.post(`/admin/admins/${id}/status`)
export const apiAdminsVerified = id => ApiService.post(`/admin/admins/${id}/verified`)

// Login History
export const apiLoginHistoryList = data => ApiService.get('/admin/login-history', data)
export const apiSetting = data => ApiService.post('/admin/setting', data)

// Roles & Permissions
export const apiPermissions = () => ApiService.get('/admin/permission-datas')
export const apiRolesList = data => ApiService.get('/admin/roles', data)
export const apiRolesView = id => ApiService.get(`/admin/roles/${id}`)
export const apiRolesForm = (id, data) => ApiService.post(`/admin/roles${id ? `/${id}` : ''}`, data)
export const apiRolesStatus = id => ApiService.post(`/admin/roles/${id}/status`)

// Users
export const apiUsersList = data => ApiService.get('/admin/users', data)
export const apiUsersView = id => ApiService.get(`/admin/users/${id}`)
export const apiUsersForm = (id, data) => ApiService.post(`/admin/users${id ? `/${id}` : ''}`, data)
export const apiUsersStatus = id => ApiService.post(`/admin/users/${id}/status`)
export const apiUsersVerified = id => ApiService.post(`/admin/users/${id}/verified`)

// Customers
export const apiCustomersList = data => ApiService.get('/admin/customers', data)
export const apiCustomersView = id => ApiService.get(`/admin/customers/${id}`)
export const apiCustomersForm = (id, data) => ApiService.post(`/admin/customers${id ? `/${id}` : ''}`, data)
export const apiCustomersStatus = id => ApiService.post(`/admin/customers/${id}/status`)
export const apiCustomersVerified = id => ApiService.post(`/admin/customers/${id}/verified`)

// Service Staffs
export const apiServiceStaffsList = data => ApiService.get('/admin/service-staffs', data)
export const apiServiceStaffsView = id => ApiService.get(`/admin/service-staffs/${id}`)
export const apiServiceStaffsForm = (id, data) => ApiService.post(`/admin/service-staffs${id ? `/${id}` : ''}`, data)
export const apiServiceStaffsStatus = id => ApiService.post(`/admin/service-staffs/${id}/status`)
export const apiServiceStaffsVerified = id => ApiService.post(`/admin/service-staffs/${id}/verified`)

// Stores
export const apiStoresList = data => ApiService.get('/admin/stores', data)
export const apiStoresView = id => ApiService.get(`/admin/stores/${id}`)
export const apiStoresForm = (id, data) => ApiService.post(`/admin/stores${id ? `/${id}` : ''}`, data)
export const apiStoresStatus = id => ApiService.post(`/admin/stores/${id}/status`)
export const apiStoresVerified = id => ApiService.post(`/admin/stores/${id}/verified`)

// Order Requests
export const apiOrderRequestsList = data => ApiService.get('/admin/order-requests', data)
export const apiOrderRequestsView = id => ApiService.get(`/admin/order-requests/${id}`)
export const apiOrderRequestsStatus = (id, data) => ApiService.post(`/admin/order-requests/${id}/status`, data)

// Orders
export const apiOrdersList = data => ApiService.get('/admin/orders', data)
export const apiOrdersView = id => ApiService.get(`/admin/orders/${id}`)
export const apiOrdersForm = (id, data) => ApiService.post(`/admin/orders${id ? `/${id}` : ''}`, data)
export const apiOrdersHistories = (id, data) => ApiService.post(`/admin/orders/${id}/histories`, data)
export const apiOrdersPayments = (id, data) => ApiService.post(`/admin/orders/${id}/payments`, data)

// Order Progress
export const apiOrderProgressList = data => ApiService.get('/admin/order-progress', data)
export const apiOrderProgressView = id => ApiService.get(`/admin/order-progress/${id}`)
export const apiOrderProgressForm = data => ApiService.post('/admin/order-progress', data)
export const apiOrderProgressStatus = (id, data) => ApiService.post(`/admin/order-progress/${id}/status`, data)

export const apiOrderDeliveriesForm = data => ApiService.post(`/admin/order-deliveries`, data)
export const apiOrderDeliveriesWarranty = (id, data) => ApiService.post(`/admin/order-deliveries/${id}`, data)
export const apiOrderDeliveriesPDF = id => ApiService.blob(`/admin/order-deliveries/${id}/pdf`)

// Warranty Services
export const apiWarrantyServicesList = data => ApiService.get('/admin/warranty-services', data)
export const apiWarrantyServicesView = id => ApiService.get(`/admin/warranty-services/${id}`)
export const apiWarrantyServicesUpdate = (id, data) => ApiService.post(`/admin/warranty-services/${id}`, data)
export const apiWarrantyServicesStatus = (id, data) => ApiService.post(`/admin/warranty-services/${id}/status`, data)
export const apiWarrantyServiceInspections = (id, machineId) =>
    ApiService.get(`/admin/warranty-services/${id}/machines/${machineId}/inspections`)
export const apiWarrantyServiceInspectionsSubmit = (id, machineId, data) =>
    ApiService.post(`/admin/warranty-services/${id}/machines/${machineId}/inspections`, data)
export const apiWarrantyServiceInspectionsPDF = (id, machineId) =>
    ApiService.get(`/admin/warranty-services/${id}/machines/${machineId}/inspections/pdf`, undefined, { responseType: 'blob' })

// Customer Requests
export const apiCustomerRequestsList = data => ApiService.get('/admin/customer-requests', data)
export const apiCustomerRequestsView = id => ApiService.get(`/admin/customer-requests/${id}`)
export const apiCustomerRequestsStatus = (id, data) => ApiService.post(`/admin/customer-requests/${id}/status`, data)

// Wallets
export const apiWalletsList = data => ApiService.get('/admin/wallets', data)

// Withdrawal Requests
export const apiWithdrawalRequestsList = data => ApiService.get('/admin/withdrawal-requests', data)
export const apiWithdrawalRequestsView = id => ApiService.get(`/admin/withdrawal-requests/${id}`)
export const apiWithdrawalRequestsStatus = (id, data) => ApiService.post(`/admin/withdrawal-requests/${id}/status`, data)

// Machine Types
export const apiMachineTypesList = data => ApiService.get('/admin/machine-types', data)
export const apiMachineTypesView = id => ApiService.get(`/admin/machine-types/${id}`)
export const apiMachineTypesForm = (id, data) => ApiService.post(`/admin/machine-types${id ? `/${id}` : ''}`, data)
export const apiMachineTypesStatus = id => ApiService.post(`/admin/machine-types/${id}/status`)

// Machines
export const apiMachinesList = data => ApiService.get('/admin/machines', data)
export const apiMachinesView = id => ApiService.get(`/admin/machines/${id}`)
export const apiMachinesForm = (id, data) => ApiService.post(`/admin/machines${id ? `/${id}` : ''}`, data)
export const apiMachinesStatus = id => ApiService.post(`/admin/machines/${id}/status`)

// Terms
export const apiTermsList = data => ApiService.get('/admin/terms', data)
export const apiTermsView = id => ApiService.get(`/admin/terms/${id}`)
export const apiTermsForm = (id, data) => ApiService.post(`/admin/terms${id ? `/${id}` : ''}`, data)
export const apiTermsStatus = id => ApiService.post(`/admin/terms/${id}/status`)

// Festival Offers
export const apiFestivalOffersList = data => ApiService.get('/admin/festival-offers', data)
export const apiFestivalOffersView = id => ApiService.get(`/admin/festival-offers/${id}`)
export const apiFestivalOffersForm = (id, data) => ApiService.post(`/admin/festival-offers${id ? `/${id}` : ''}`, data)
export const apiFestivalOffersStatus = id => ApiService.post(`/admin/festival-offers/${id}/status`)

// Service Inspections
export const apiServiceInspectionsList = data => ApiService.get('/admin/service-inspections', data)
export const apiServiceInspectionsView = id => ApiService.get(`/admin/service-inspections/${id}`)
export const apiServiceInspectionsForm = (id, data) => ApiService.post(`/admin/service-inspections${id ? `/${id}` : ''}`, data)
export const apiServiceInspectionsStatus = id => ApiService.post(`/admin/service-inspections/${id}/status`)

// Machine Demos
export const apiMachineDemosList = data => ApiService.get('/admin/machine-demos', data)
export const apiMachineDemosView = id => ApiService.get(`/admin/machine-demos/${id}`)
export const apiMachineDemosForm = (id, data) => ApiService.post(`/admin/machine-demos${id ? `/${id}` : ''}`, data)
export const apiMachineDemosStatus = id => ApiService.post(`/admin/machine-demos/${id}/status`)
